import Bugsnag from '@bugsnag/js'
import { useQuery } from 'react-query'

import { getStatusPage } from '../api'

export const useStatusPageData = () => {
  const { data } = useQuery(
    ['statusPage'],
    ({ signal }) =>
      getStatusPage(signal).then(data => ({
        errorComponents: data.components.filter(component => component.status !== 'operational'),
      })),
    {
      onError: error => {
        if (error instanceof Error) {
          Bugsnag.notify(error)
        }
      },
    }
  )

  return {
    errorComponents: data?.errorComponents ?? [],
  }
}
